'use strict';

angular
	.module('theme')
	.service(
		'ShopService',
		function ($rootScope, $q, $http, $cookies, CustomerService, LANG) {
			var service = this;

			this.getProducts = function () {
				if ($rootScope.publicShop) {
					return $http({
						url: '/backapi/ShopArticles',
						method: 'POST',
						data: {},
						cache: false,
					}).then(function (response) {
						return response.data;
					});
				}

				// We need to get the customer id first if logged in
				return CustomerService.get().then(function (customer) {
					service.customerId = customer.id;

					var data = {
						customerID: service.customerId,
					};

					return $http({
						url: '/backapi/ShopArticles',
						method: 'POST',
						data: data,
						cache: false,
					}).then(function (response) {
						return response.data;
					});
				});
			};

			this.checkout = function (cart) {
				if (cart.customerID) {
					service.customerID = cart.customerID;
				}

				return $http({
					url: '/backapi/ShopCartCheckout',
					method: 'POST',
					data: cart,
					cache: false,
				}).then(function (response) {
					return response.data;
				});
			};

			this.getSummary = function (cart) {
				return service.checkout(cart).then(function() {
					return $http({
						url: '/backapi/ShopCartSummary',
						method: 'POST',
						data: cart,
						cache: false,
					}).then(function (response) {
						return response.data;
					});
				});
			};

			this.getShopDeliveryDate = function () {
				var cart = service.getCart();

				return $http({
					url: '/backapi/ShopCartSummary',
					method: 'POST',
					data: cart || {},
					cache: false,
				}).then(function (response) {
					if (response.data && response.data.deliveryDate) {
						return moment(response.data.deliveryDate)
							.locale(LANG)
							.format('dddd D MMMM');
					}

					return false;
				});
			};

			this.order = function (cart) {
				return $http({
					url: '/backapi/ShopCartOrder',
					method: 'POST',
					data: cart,
					cache: false,
				}).then(function (response) {
					service._removeCookie();

					return response.data;
				});
			};

			this.getCart = function () {
				return service._getCookie();
			};

			this.setCart = function (cart) {
				return service._setCookie(cart);
			};

			this.getCartAmount = function (product) {
				var cart = service.getCart();

				if (!cart || cart.cartArticles.length === 0) {
					return 0;
				}

				var article = _.find(cart.cartArticles, function (article) {
					return article.shopArticleID === product.shopArticleID;
				});

				return (article && article.number) || 0;
			};

			this.getTotalCartAmount = function () {
				var cart = service.getCart();

				if (!cart || cart.cartArticles.length === 0) {
					return 0;
				}

				var totalAmount = 0;

				_.each(cart.cartArticles, function (article) {
					totalAmount += article.number;
				});

				return totalAmount;
			};

			this.addToCart = function (product) {
				var cart = service.getCart();

				// Create new cart object if not already created
				if (!cart) {
					cart = service.createCart();
				}

				// If public shop and not valid zipcode show check zipcode overlay
				if ($rootScope.publicShop && (!cart.zipcode || !cart.validZipcode)) {
					$rootScope.$emit('shop-zipcode.check', product);
					return;
				}

				var article = {};

				// Add product to cart
				if (cart.cartArticles.length > 0) {
					var articleIndex = _.findIndex(
						cart.cartArticles,
						function (article) {
							return (
								article.shopArticleID === product.shopArticleID
							);
						}
					);

					if (articleIndex === -1) {
						article = {
							shopArticleID: product.shopArticleID,
							name: product.name,
							descriptionDelivery: product.descriptionDelivery,
							img: product.imageSmall,
							number: 1,
						};
						cart.cartArticles.push(article);
						$rootScope.$emit('shop-cart.add', product);
					} else {
						cart.cartArticles[articleIndex].number++;
					}
				} else {
					article.shopArticleID = product.shopArticleID;
					article.descriptionDelivery = product.descriptionDelivery,
					article.number = 1;
					article.name = product.name;
					article.img = product.imageSmall;
					cart.cartArticles.push(article);
					$rootScope.$emit('shop-cart.add', product);
				}

				service._setCookie(cart);
				service.checkout(cart);
			};

			this.createCart = function() {
				var cart;

				if ($rootScope.publicShop) {
					cart = {
						externalID: service.uuidv4(), // Generate exteranlID for backend
						cartArticles: [],
					};
				} else {
					cart = {
						customerID: service.customerId,
						cartArticles: [],
					};
				}

				return cart;
			};

			this.removeFromCart = function (product) {
				var cart = service.getCart();

				if (!cart || cart.cartArticles.length === 0) return;

				var articleIndex = _.findIndex(
					cart.cartArticles,
					function (article) {
						return article.shopArticleID === product.shopArticleID;
					}
				);

				if (articleIndex !== -1) {
					var article = cart.cartArticles[articleIndex];

					if (article.number === 1) {
						cart.cartArticles.splice(articleIndex, 1);
					} else {
						cart.cartArticles[articleIndex].number--;
					}
				}

				this._setCookie(cart);
				service.checkout(cart);
			};

			this.clearCart = function (cart) {
				// Clear reserved products in backend
				if (cart) {
					cart.cartArticles = [];
					this.checkout(cart);
				}

				this._setCookie(cart);

				$rootScope.$emit('shop-cart.update');
				$rootScope.$emit('shop-cart.clear');
			};

			this.removeCart = function() {
				service._removeCookie();

				$rootScope.$emit('shop-cart.update');
			};

			this._removeCookie = function () {
				$cookies.remove('shop-cart', {
					path: '/',
				});
			};

			this._getCookie = function () {
				return $cookies.getObject('shop-cart');
			};

			this._setCookie = function (cart) {
				if (!cart) return;

				// Set shop cart expire in 20 minutes
				var expires = moment().add(20, 'minutes').format();
				cart.expires = expires;
				cart.notice = false;
			
				$cookies.putObject('shop-cart', cart, {
					path: '/',
					expires: expires
				});

				$rootScope.$emit('shop-cart.update');
			};

			this.uuidv4 = function () {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
					/[xy]/g,
					function (c) {
						var r = (Math.random() * 16) | 0,
							v = c == 'x' ? r : (r & 0x3) | 0x8;
						return v.toString(16);
					}
				);
			};
		}
	);
